import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=5e0dd280&"
import script from "./PersonalData.vue?vue&type=script&lang=js&"
export * from "./PersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports